import { range } from 'lodash';
import styled from 'styled-components';
import { BouRadioButtonWithLabel } from '../../../../../generic/components/inputs/bou-radio-button-with-label';

export const steps = 6;
export const stepRange = range(0, steps);

export const ValueSelectorRadioButton = styled(BouRadioButtonWithLabel).attrs({
  radioSize: '1.2em',
})`
  padding: 0 0.25em;
`;
